// extracted by mini-css-extract-plugin
export default {"next_order":"Hx","recurringdis":"Ix","reactivate_button":"Jx","order__summary_title":"Kx","order__summary_items":"Lx","order__summary_item":"Mx","order__summary_item_title":"Nx","order__summary_item_quantity":"Ox","order__item_separator":"Px","discount":"Qx","promowrapper":"Rx"};
    if(module.hot) {
      // 1743628922964
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  